import { AppState } from '@/lib/store';
import Flow, { Chat } from '@/types/flow';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: DeclareCatalogProduct.State = {
  CatalogProductHeader: {},
};

const catalogProductSlice = createSlice({
  name: 'catalogProduct',
  initialState: initialState,
  reducers: {
    setCatalogProduct: (state, action) => {
      state.CatalogProductHeader = action.payload;
    },
  },
});

export const { setCatalogProduct } = catalogProductSlice.actions;

export const selectCatalogProduct = (state: AppState) => state.catalogProduct;

export default catalogProductSlice.reducer;
